import axios from 'axios';
import { apiUrl } from './apiUrl';
axios.defaults.headers.common['Authorization'] = localStorage.getItem('loginToken') || '';

export const get = (start, stop) =>
    axios.get(`${apiUrl}/dashboardstats`, { params: { start, stop } })


// WEBPACK FOOTER //
// ./src/baseparking-api/Dashboard.js